/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated';
import { createObjectNode } from '../../factoriesAny.js';
export var ObjectNodeDependencies = {
  NodeDependencies: NodeDependencies,
  createObjectNode: createObjectNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesObjectNode.generated.js
// module id = 641
// module chunks = 0